module.exports = __webpack_public_path__ + "img/electrical_online.6c634da6.png";